module.exports = __webpack_public_path__ + "img/bound.c460ce0a.jpg";